import { combineReducers } from 'redux';

import reportBlock from 'af-reducers/reportBlock.reducer';

import type { SettingsStoreState } from 'af-models/settings.models';

export default combineReducers<SettingsStoreState>({
	reportBlock,
});
